import Http from 'services/Http';
import sanitizeAgenticBody from './sanitizeAgenticBody';

class AgentSkillApi {
  list() {
    return Http.get('/v1/skills').then(r => r.data.skills);
  }

  get(id) {
    return Http.get(`/v1/skills/${id}`).then(r => r.data.skill);
  }

  create(body) {
    return Http.post('/v1/skills', sanitizeAgenticBody(body)).then(r => r.data.skill);
  }

  update(id, body) {
    return Http.put(`/v1/skills/${id}`, sanitizeAgenticBody(body)).then(r => r.data.skill);
  }

  destroy(id) {
    return Http.delete(`/v1/skills/${id}`);
  }
}

export default new AgentSkillApi();
